import { render, staticRenderFns } from "./1_InterdictionAccueil.vue?vue&type=template&id=23f32177&scoped=true&"
import script from "./1_InterdictionAccueil.vue?vue&type=script&lang=js&"
export * from "./1_InterdictionAccueil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f32177",
  null
  
)

export default component.exports